import * as React from 'react'

import * as T from 'components/ui/typography'

import { WorkspaceButtonProps } from '.'
import router from 'next/router'
import { AuthContext } from 'providers/auth-provider'
import { SelectItem } from 'components/ui/select'
import CAvatar from 'components/shared/avatar'
import { PlusCircle } from 'lucide-react'

const WorkspaceItems = ({ workspaceList, selectWorkspace }: WorkspaceButtonProps) => {
    const { authData } = React.useContext(AuthContext)

    const handleAddWorkspace = () => {
        router.push('/workspace')
    }

    return (
        <div className="pr-2">
            {workspaceList?.map((i, index) => {
                return (
                    <SelectItem
                        key={index}
                        value={i._id}
                        className="flex flex-row rounded-lm p-1 my-3 cursor-pointer min-w-full hover:bg-primary hover:text-white">
                        <div onClick={() => selectWorkspace(authData?.userUid || '', i._id)} className="flex">
                            <CAvatar src={i.logo_url} fallback="WS" className="h-6 w-6 mr-2" />

                            <p className="text-sm font-regular font-[Manrope]">{i.name}</p>
                        </div>
                    </SelectItem>
                )
            })}
            <hr />
            <div onClick={handleAddWorkspace} className="flex p-2 items-center rounded-xl cursor-pointer">
                <PlusCircle className="fill-neutral-300 text-white mr-1 h-5 w-5" />

                <T.Muted>Aggiungi</T.Muted>
            </div>
        </div>
    )
}

export default WorkspaceItems
